
      <div>
          <a (click)="modify()" *ngIf="!editMode && isShowMod" title="修改"><i class="anticon anticon-edit"></i></a>
          <a (click)="delete()" *ngIf="!editMode && isShowDel" title="删除"><i class="anticon anticon-delete color-error"></i></a>
          <a (click)="save()" *ngIf="editMode" title="保存"><i class="anticon anticon-check"></i></a>
          <a (click)="cancel()" *ngIf="editMode" title="取消"><i class="anticon anticon-close color-error"></i></a>
      </div>